// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {getFirestore} from "firebase/firestore";
import { getMessaging } from "firebase/messaging"
import appConfig from "@/config/appConfig";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: appConfig.VUE_APP_FIREBASE_API_KEY,
  authDomain: appConfig.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: appConfig.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: appConfig.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: appConfig.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: appConfig.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: appConfig.VUE_APP_FIREBASE_APP_ID,
  measurementId: appConfig.VUE_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db=getFirestore(app);
const storage=getStorage(app);
const messaging = getMessaging(app);

export {db,storage,messaging};
